import React from 'react';
import BundleResultItem from "@app/react/components/BundleResultItem/BundleResultItem.jsx";
export default function CollectionBundles({bundlesByFrame}) {
  return <>
      <div className='row'>
        <div className='col-lg-2'>
          <nav className='side-menu'>
            <ul>
              {bundlesByFrame.map(bundleType =>
                <li><a key={bundleType.id} href={'#version-'+bundleType.id}>{bundleType.name}</a></li>
              )}
            </ul>
          </nav>
        </div>
        <div className='col-lg-10'>
          {bundlesByFrame.map(bundleType =>  <div className='row' id={'version-'+bundleType.id}>
            <div className='col-12'>
              <div className='row'>
                {bundleType.bundles.map(bundle =><div className='col-md-3 col-sm-6'><BundleResultItem key={bundle.id} bundle={bundle} configurationLink={true} pageLink={true} /></div>)}
              </div>
            </div>
          </div>
          )}
        </div>
      </div>
  </>
}
